import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './widget-api'; // Charger l'API globale du widget

// Vérifier si on est dans un environnement de démo ou de widget
const isDemoMode = document.getElementById('root') !== null;

console.log('🔍 Mode détection:', { isDemoMode, hasRoot: !!document.getElementById('root') });

if (isDemoMode) {
  // Mode démo - afficher l'application complète
  console.log('🎯 Mode démo activé');
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  // Mode widget standalone - initialiser automatiquement le widget
  console.log('🎯 Mode widget standalone - initialisation automatique du widget');
  
  // Fonction d'initialisation avec retry
  const initWidget = (attempt = 1, maxAttempts = 20) => {
    console.log(`🔍 Tentative ${attempt}/${maxAttempts} d'initialisation du widget...`);
    
    if ((window as any).HectorWidget) {
      console.log('✅ HectorWidget trouvé, initialisation...');
      try {
        (window as any).HectorWidget.init({
          position: 'bottom',
          buttonColor: '#1a1a1a'
        });
        console.log('🎉 Widget initialisé avec succès !');
        return;
      } catch (error) {
        console.error('❌ Erreur lors de l\'initialisation:', error);
      }
    } else {
      console.log('❌ HectorWidget non trouvé');
    }
    
    // Retry si pas encore au maximum
    if (attempt < maxAttempts) {
      console.log(`⏳ Nouvelle tentative dans 500ms...`);
      setTimeout(() => initWidget(attempt + 1, maxAttempts), 500);
    } else {
      console.error('❌ Échec de l\'initialisation après', maxAttempts, 'tentatives');
    }
  };
  
  // Attendre que le DOM soit prêt
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      console.log('📄 DOM chargé, initialisation du widget...');
      setTimeout(() => initWidget(), 100);
    });
  } else {
    // DOM déjà prêt
    console.log('📄 DOM déjà prêt, initialisation du widget...');
    setTimeout(() => initWidget(), 100);
  }
}
